import React, {Fragment, useContext} from "react";
import {SearchOptionsContext} from "../../context/search-options-context";
import CheckboxColumnList from "../../components/CheckboxColumnList/CheckboxColumnList";

function StepForGearbox(props) {

    const searchOptions = useContext(SearchOptionsContext);
    const gearboxTypes = [...new Set(searchOptions.gearboxTypes)].map(name => ({name}));

    return (
        <Fragment>

            <div className="config-modal-body">

                <h5 className="center">Szukasz auta w automacie czy manualu?</h5>
                <form id="gearbox-konfig">
                    <CheckboxColumnList
                        selectedItems={props.gearboxTypes}
                        columnCount={1}
                        items={gearboxTypes}
                        onChange={props.onChange}
                    />
                </form>

            </div>

            <div className="config-modal-footer">

                <div className="flex">
                    <button type="button" className="back" onClick={props.onBackClick}><i className="fa fa-angle-left"></i> Wstecz</button>
                    <button type="button" onClick={props.onNextClick}>Dalej <i className="fa fa-angle-right"></i></button>
                </div>

            </div>
        </Fragment>
    );
}

export default StepForGearbox;
